import React from 'react';
import type { VolumePage } from '../data/volumeOnePages';
type PageCardProps = {
  page: VolumePage;
  onOpen: () => void;
  tabbable?: boolean;
};

/** One 9:16 page: never cropped, opens the lightbox on click/tap. */
export function PageCard({
  page,
  onOpen,
  tabbable = true
}: PageCardProps) {
  return <button type="button" onClick={onOpen} tabIndex={tabbable ? 0 : -1} aria-label={`Open full screen: ${page.caption}`} className="block w-full cursor-zoom-in overflow-hidden rounded-[12px] border border-[#E6E2DA] bg-white shadow-[0_1px_2px_rgba(34,48,60,0.06),0_12px_28px_-10px_rgba(34,48,60,0.22)] focus:outline-none focus-visible:ring-4 focus-visible:ring-[#4C5FD5]/40" data-id="element-173" data-mp="cuk3wjtk8gjb">
      <img src={page.src} alt={page.caption} loading="lazy" decoding="async" width={1080} height={1920} className="block aspect-[9/16] w-full object-contain" data-id="element-174" data-mp="vjqflmvxs7vm" />
    </button>;
}